/**
 * Keeps storefront product links canonical even when Shopify apps or search
 * responses attach tracking parameters to a product URL.
 */
(() => {
  'use strict';

  const isProductUrl = (url) => url.origin === window.location.origin && url.pathname.startsWith('/products/');

  const canonicalProductUrl = (url) => {
    const canonical = new URL(url.href);
    canonical.search = '';
    return canonical;
  };

  const cleanProductLink = (anchor) => {
    if (!(anchor instanceof HTMLAnchorElement) || !anchor.href) return;

    const url = new URL(anchor.href, window.location.origin);
    if (!isProductUrl(url) || !url.search) return;

    anchor.href = canonicalProductUrl(url).href;
  };

  // Runs before the browser follows a link, including links injected by apps.
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      cleanProductLink(target.closest('a[href]'));
    },
    true
  );

  // A direct visit from Shopify search/recommendations is cleaned in-place so
  // the address bar, sharing URL and browser history use the canonical route.
  const currentUrl = new URL(window.location.href);
  if (isProductUrl(currentUrl) && currentUrl.search) {
    window.history.replaceState(window.history.state, '', canonicalProductUrl(currentUrl).pathname + currentUrl.hash);
  }
})();
